import { BranchMinimumCartSystemsService } from '@/backend/market/services/BranchMinimumCartSystemsService'
import type {
  BranchMinimumCartSystemAdminDto,
  PostPutBranchMinimumCartSystemRequestAdmin
} from '@/backend/market'
import { BranchMinimumCartSystemRepository } from '../../domain/repositories/BranchMinimumCartSystemRepository'
import { BranchMinimumCartSystemModel } from '../models/BranchMinimumCartSystemModel'
import { BranchMinimumCartSystemMiniModel } from '../models/BranchMinimumCartSystemMiniModel'
import { BranchMinimumCartSystemFilterModel } from '../models/BranchMinimumCartSystemFilterModel'
import { CreateUpdateBranchMinimumCartSystemModel } from '../models/CreateUpdateBranchMinimumCartSystemModel'
import type { BranchMinimumCartSystemEntity } from '../../domain/entities/BranchMinimumCartSystemEntity'
import type { BranchMinimumCartSystemFilterEntity } from '../../domain/entities/BranchMinimumCartSystemFilterEntity'
import type { BranchMinimumCartSystemMiniEntity } from '../../domain/entities/BranchMinimumCartSystemMiniEntity'
import type { PaginateEntity } from '@/shared/entities/PaginateEntity'

export class BranchMinimumCartSystemRepositoryImpl implements BranchMinimumCartSystemRepository {
  async getBranchMinimumCartSystems(
    filterData: BranchMinimumCartSystemFilterEntity
  ): Promise<PaginateEntity<BranchMinimumCartSystemMiniEntity> | { error: true }> {
    const filterModel = new BranchMinimumCartSystemFilterModel(filterData)
    try {
      const response = await BranchMinimumCartSystemsService.getBranchMinimumCartSystemsAdmin(
        filterModel as {}
      )
      const models =
        response.items?.map(
        (item) => new BranchMinimumCartSystemMiniModel(item as BranchMinimumCartSystemAdminDto)
        ) ?? []
      return {
        ...response,
        items: models
      }
    } catch {
      return { error: true }
    }
  }

  async getBranchMinimumCartSystem(
    branchMinimumCartSystemId: number
  ): Promise<BranchMinimumCartSystemEntity | { error: true }> {
    try {
      const response = await BranchMinimumCartSystemsService.getBranchMinimumCartSystemAdmin({
        branchMinimumCartSystemId
      })
      return new BranchMinimumCartSystemModel(response as BranchMinimumCartSystemAdminDto)
    } catch {
      return { error: true }
    }
  }

  async createBranchMinimumCartSystem(
    data: BranchMinimumCartSystemEntity
  ): Promise<{ success: true } | { error: true }> {
    const model = new CreateUpdateBranchMinimumCartSystemModel(data)
    try {
      await BranchMinimumCartSystemsService.postBranchMinimumCartSystemAdmin({
        requestBody: model as unknown as PostPutBranchMinimumCartSystemRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updateBranchMinimumCartSystem(
    branchMinimumCartSystemId: number,
    data: BranchMinimumCartSystemEntity
  ): Promise<{ success: true } | { error: true }> {
    const model = new CreateUpdateBranchMinimumCartSystemModel(data)
    try {
      await BranchMinimumCartSystemsService.putBranchMinimumCartSystemAdmin({
        branchMinimumCartSystemId,
        requestBody: model as unknown as PostPutBranchMinimumCartSystemRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteBranchMinimumCartSystem(
    branchMinimumCartSystemId: number
  ): Promise<{ success: true } | { error: true }> {
    try {
      await BranchMinimumCartSystemsService.deleteBranchMinimumCartSystemAdmin({
        branchMinimumCartSystemId
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
